import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { distinctUntilChanged, finalize, startWith, take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { CommunicationsService } from "src/app/modules/communications/communications.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { ChooseRecipientDialogComponent } from "src/app/shared/components/dialogs/choose-recipient-dialog/choose-recipient-dialog.component";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { DocumentArchivesService } from "../../document-archives.service";
var CancelContractDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function CancelContractDialogComponent(dialogRef, data, confirmDialog, chooseRecipientsDialog, configService, cookieService, toastrService, translateService, communicationsService, companiesService, authService, helperService, documentArchivesService, apiService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.confirmDialog = confirmDialog;
        this.chooseRecipientsDialog = chooseRecipientsDialog;
        this.configService = configService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.communicationsService = communicationsService;
        this.companiesService = companiesService;
        this.authService = authService;
        this.helperService = helperService;
        this.documentArchivesService = documentArchivesService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.loggedUser = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.customContactField = [];
        this.options = {};
        this.showBcc = false;
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("properties.dialog.contractCancellationContinue"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-paper-plane",
                inline: true,
            },
        };
        this.attachmentBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.attach"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "accent",
            spinnerColor: "accent",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-paperclip",
                inline: true,
            },
        };
        // END - Add communication form
        this.dialogIsLoading = true;
        this.isAdmin = false;
        this.isMaster = false;
        this.phonebook = [];
        this.companyId = "";
        this.step1 = true;
        this.docs = [];
        this.selectedDocs = [];
        this.barCode = "";
    }
    /**
     * Init component
     *
     */
    CancelContractDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            return _this.loggedUser.setData(res);
        }));
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "admin" ||
            this.authService.loggedUserRequestedRoleType$.getValue() === "operator") {
            this.isAdmin = true;
        }
        if (this.authService.loggedUserRequestedRoleType$.getValue() === "master" ||
            this.authService.loggedUserRequestedRoleType$.getValue() ===
                "collaborator") {
            this.isMaster = true;
        }
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        this.documentArchivesService
            .getDocsByBarcode(this.data.contract.documentArchiveId, this.data.contract.barCode)
            .subscribe(function (res) {
            if (res.status) {
                if (res.data && Array.isArray(res.data)) {
                    res.data.forEach(function (item) {
                        _this.docs.push({
                            _id: item._id,
                            docTitle: item.docTitle,
                            structureObjectName: item.structureObjectName,
                            structureObjectId: item.structureObjectId,
                            data: item.data,
                            checked: false
                        });
                    });
                }
            }
            else {
                _this.toastrService.error(res.message);
            }
            _this.dialogIsLoading = false;
        });
        this.barCode = this.data.contract.barCode.substring(this.data.contract.barCode.length - 7);
        // Set company
        this.companyId = this.cookieService.get("requestedCompany");
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Update docs array with incoming element
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.onDocSelected = function (doc, checked) {
        if (doc && checked) {
            this.selectedDocs.push(doc);
        }
        else if (doc && !checked) {
            var index = this.selectedDocs.findIndex(function (el) { return el._id === doc._id; });
            if (index > -1) {
                this.selectedDocs.splice(index, 1);
            }
        }
    };
    /**
     * Handle step 2, hide docs selection and show email form
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.onStep2 = function () {
        this.step1 = false;
        this.dialogIsLoading = true;
        // Get form initial values and init the form
        this.getDataAndInitForm();
    };
    /**
     * Preload data and then init form. If something
     * goes wrong just init the form
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.getDataAndInitForm = function () {
        var e_1, _a, e_2, _b;
        var _this = this;
        // Normalize each file inside doc
        if (!this.model.docs) {
            this.model = tslib_1.__assign({}, this.model, { docs: [] });
        }
        try {
            for (var _c = tslib_1.__values(this.selectedDocs), _d = _c.next(); !_d.done; _d = _c.next()) {
                var doc = _d.value;
                if (doc &&
                    (!Array.isArray(doc.data.document) || doc.data.document.length === 0)) {
                    return;
                }
                try {
                    for (var _e = (e_2 = void 0, tslib_1.__values(doc.data.document)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var document_1 = _f.value;
                        var newDoc = {};
                        newDoc = {
                            key: document_1._id,
                            value: doc.docTitle + " " + doc.structureObjectName + " - " + document_1.originalName,
                            path: document_1.path,
                        };
                        this.model.docs.push(newDoc);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Get available recipients from phonebook
        if (this.isAdmin) {
            this.subscriptions.push(this.companiesService
                .getPhonebookListAdmin(0, null, null, "asc")
                .subscribe(function (res) {
                if (res.status) {
                    _this.phonebook = res.data.items;
                    _this.initForm();
                }
                _this.dialogIsLoading = false;
            }, function (err) {
                _this.dialogIsLoading = false;
                _this.helperService.handleError(err);
            }));
        }
        else if (this.isMaster) {
            this.subscriptions.push(this.companiesService
                .getPhonebookList(this.companyId, 0, null, null, "asc")
                .subscribe(function (res) {
                if (res.status) {
                    _this.phonebook = res.data.items;
                    _this.initForm();
                }
                _this.dialogIsLoading = false;
            }, function (err) {
                _this.dialogIsLoading = false;
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * Autofill body on cancellationType changes
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.updateCancellationType = function () {
        var _this = this;
        var cancellationTypeControl = this.form.controls.cancellationType;
        var bodyControl = this.form.controls.body;
        if (cancellationTypeControl) {
            cancellationTypeControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(cancellationTypeControl.value))
                .subscribe(function (res) {
                var e_3, _a;
                if (!res) {
                    return;
                }
                var titles = '';
                try {
                    for (var _b = tslib_1.__values(_this.selectedDocs), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var doc = _c.value;
                        titles = titles + "- " + doc.docTitle + " " + doc.structureObjectName + "\n";
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                if (res === 'expiration') {
                    bodyControl.setValue(_this.translateService.instant("communications.fields.cancelContractBody", { titles: titles }));
                }
                else if (res === 'immediate') {
                    bodyControl.setValue(_this.translateService.instant("communications.fields.cancelContractImmediateBody", { titles: titles }));
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.initForm = function () {
        var _this = this;
        // Minimum char amount to activate search filtering
        var minTermLength = 1;
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: "row",
                hooks: {
                    onInit: function (fieldConfig) {
                        _this.updateCancellationType();
                    },
                },
                fieldGroup: [
                    {
                        className: "col-12 mt-3 radio-wrapper",
                        type: "radio",
                        key: "cancellationType",
                        defaultValue: "immediate",
                        templateOptions: {
                            label: this.translateService.instant("communications.fields.cancelContractType"),
                            options: [
                                {
                                    value: "immediate",
                                    label: this.translateService.instant("communications.fields.cancelContractImmediate"),
                                },
                                {
                                    value: "expiration",
                                    label: this.translateService.instant("communications.fields.cancelContractExpiration"),
                                },
                            ],
                        },
                    },
                    {
                        key: "sender",
                        hide: true,
                        templateOptions: {
                            value: this.loggedUser.get("email"),
                        },
                    },
                    {
                        className: "col-11 mb-0 autocomplete-multi-email",
                        type: "autocomplete",
                        key: "recipients",
                        templateOptions: {
                            customLabel: this.translateService.instant("communications.fields.recipients"),
                            required: true,
                            bindLabel: "email",
                            bindValue: "email",
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            addTagText: this.translateService.instant("common.words.addTag"),
                            loadingText: this.translateService.instant("common.words.loading"),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipients;
                            },
                        },
                    },
                    {
                        className: "col-1 mb-0",
                        type: "button",
                        key: "openPhonebook",
                        templateOptions: {
                            color: "accent",
                            tooltip: "tooltip",
                            icon: {
                                fontSet: "fas",
                                fontIcon: "fa-book-user",
                            },
                            onClick: function ($event) {
                                return _this.onChooseRecipientDialogOpen("recipients");
                            },
                        },
                    },
                    {
                        className: "col-11 mb-0 autocomplete-multi-email",
                        type: "autocomplete",
                        key: "recipientsCc",
                        // hideExpression: (model): boolean => !model.showCc,
                        templateOptions: {
                            customLabel: this.translateService.instant("communications.fields.recipientsCc"),
                            required: false,
                            bindLabel: "email",
                            bindValue: "email",
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            addTagText: this.translateService.instant("common.words.addTag"),
                            loadingText: this.translateService.instant("common.words.loading"),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipientsCc;
                            },
                        },
                    },
                    {
                        className: "col-1 mb-0",
                        type: "button",
                        key: "openPhonebook",
                        templateOptions: {
                            color: "accent",
                            tooltip: "tooltip",
                            icon: {
                                fontSet: "fas",
                                fontIcon: "fa-book-user",
                            },
                            onClick: function ($event) {
                                return _this.onChooseRecipientDialogOpen("recipientsCc");
                            },
                        },
                    },
                    {
                        className: "col-11 mb-0 autocomplete-multi-email",
                        type: "autocomplete",
                        key: "recipientsBcc",
                        // hideExpression: (model): boolean => !model.showBcc,
                        templateOptions: {
                            customLabel: this.translateService.instant("communications.fields.recipientsBcc"),
                            required: false,
                            bindLabel: "email",
                            bindValue: "email",
                            multiple: true,
                            search$: this.isMaster
                                ? this.companiesService.getPhonebookListMaster.bind(this)
                                : this.companiesService.getPhonebookListAdmin.bind(this),
                            hideSelected: true,
                            addTag: true,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            addTagText: this.translateService.instant("common.words.addTag"),
                            loadingText: this.translateService.instant("common.words.loading"),
                        },
                        expressionProperties: {
                            "templateOptions.onChange": function (model) {
                                return model.recipientsBcc;
                            },
                        },
                    },
                    {
                        className: "col-1 mb-0",
                        type: "button",
                        key: "openPhonebook",
                        templateOptions: {
                            color: "accent",
                            tooltip: "tooltip",
                            icon: {
                                fontSet: "fas",
                                fontIcon: "fa-book-user",
                            },
                            onClick: function ($event) {
                                return _this.onChooseRecipientDialogOpen("recipientsBcc");
                            },
                        },
                    },
                    {
                        className: "col-12 mb-0",
                        template: "<hr>",
                    },
                    {
                        className: "col-12 pt-2 mb-1",
                        type: "input",
                        key: "subject",
                        defaultValue: this.data.subject ? this.data.subject : "",
                        templateOptions: {
                            label: this.translateService.instant("communications.fields.subject"),
                            placeholder: this.translateService.instant("communications.fields.subject"),
                            required: false,
                            minLength: 1,
                            maxLength: 200,
                        },
                    },
                    {
                        className: "col-12",
                        type: "textarea",
                        key: "body",
                        defaultValue: this.data.body ? this.data.body : "",
                        templateOptions: {
                            label: this.translateService.instant("communications.fields.body"),
                            placeholder: this.translateService.instant("communications.fields.body"),
                            required: true,
                            maxLength: 1000,
                            rows: 6,
                        },
                    },
                    {
                        className: "col-12 col-md-6 mb-0",
                        type: "file-uploader",
                        key: "attachments",
                        templateOptions: {
                            required: false,
                            allowedFilesNumber: 3,
                            customLabel: this.translateService.instant("communications.fields.attachments"),
                        },
                    },
                ],
            },
        ];
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.onClose = function (data, created) {
        var _this = this;
        // Prevent unsaved data loss
        if (!created && this.form.dirty && !this.form.pristine) {
            var confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: "50%",
                maxHeight: "98vh",
                data: {
                    title: this.translateService.instant("common.warnings.warning"),
                    message: this.translateService.instant("common.warnings.unsavedData"),
                    btnOkText: this.translateService.instant("common.cta.continue"),
                    btnCancelText: this.translateService.instant("common.cta.undo"),
                },
                disableClose: true,
            });
            // Subscribe to dialog result (only for 1 emit thanks to "take()")
            confirmDialogRef
                .beforeClosed()
                .pipe(take(1))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                _this.dialogRef.close(data);
                return;
            });
        }
        else {
            this.dialogRef.close(data);
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.onFormSubmit = function () {
        var _this = this;
        // One message at a time: «Prosegui» is off from the click to the answer of the back-end, so a
        // second click can neither open a second confirmation nor send the cancellation twice
        if (this.formBtnOptions.active || this.formBtnOptions.disabled) {
            return;
        }
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            return;
        }
        this.formBtnOptions.disabled = true;
        // Set recipients in model
        // this.model = {
        //   ...this.model,
        //   recipients: this.selectedRecipients.map((obj: any) => obj.email),
        // };
        var confirmDialogRef;
        // Email subject is not mandatory, but if it's empty we open a confirm dialog
        // to inform user that there's no subject in mail
        if (!this.form.controls["subject"].value) {
            confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: "50%",
                maxHeight: "98vh",
                data: {
                    title: this.translateService.instant("dialogs.confirm.title"),
                    message: this.translateService.instant("communications.add.noSubjectDialog.message"),
                    btnOkText: this.translateService.instant("communications.add.noSubjectDialog.confirm"),
                    btnOkIcon: "fa-paper-plane",
                    btnCancelText: this.translateService.instant("common.cta.undo"),
                    btnCancelIcon: "fa-times-circle",
                },
            });
        }
        else {
            // Open confirm dialog before sending email
            confirmDialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
                minWidth: "50%",
                maxHeight: "98vh",
                data: {
                    title: this.translateService.instant("dialogs.confirm.title"),
                    message: this.translateService.instant("communications.add.confirmMessage"),
                    btnOkText: this.translateService.instant("common.cta.send"),
                    btnOkIcon: "fa-paper-plane",
                    btnCancelText: this.translateService.instant("common.cta.undo"),
                    btnCancelIcon: "fa-times-circle",
                },
            });
        }
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        confirmDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // Back to main dialog
                _this.formBtnOptions.disabled = false;
                return;
            }
            // User confirmed, can send mails
            _this.dialogIsLoading = true;
            _this.formBtnOptions.active = true;
            _this.createCommunication();
        });
    };
    /**
     * Create a new communication and send it
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.createCommunication = function () {
        var _this = this;
        // If message has no subject, let's put a default one before sending
        if (this.model && !this.model.subject) {
            this.model.subject = this.translateService.instant("communications.add.defaultSubject");
        }
        // Handle body formatting. Built on a copy: the text in the dialog stays as typed, so a retry
        // after a failure sends the list once
        var body = this.model.body.concat("<ul>");
        this.model.docs.forEach(function (doc) {
            if (!doc.path) {
                // This would never happen
                _this.toastrService.error("common.errors.unknown");
                return;
            }
            var name = doc.value;
            var path = doc.path.replace(/src[\\\/]assets/g, 'public');
            var url = "";
            if (path.substring(0, 22) === "https://app.archedi.it") {
                // url = path;
                // `docFilename` keeps its leading slash, so no slash is added after "documents"
                var docFilename = path.substr(path.lastIndexOf("/"));
                url = _this.configService.apiHost + "/uploads/properties/" + _this.data.contract.propertyId + "/documents" + docFilename;
            }
            else if (/^https?:\/\//i.test(path)) {
                // Already a complete address: prefixing the API host would double it
                url = path;
            }
            else {
                url = _this.configService.apiHost + "/" + path.replace(/^\/+/, '');
            }
            // Names and addresses are stored data: escaped, so that a "&" or a "<" cannot break the list
            var safeName = _this.escapeHtml(name);
            var safeUrl = _this.escapeHtml(url);
            body = body.concat("<li>" + safeName + ": <a href=\"" + safeUrl + "\">" + safeUrl + "</a></li><br>");
        });
        body = body.concat("</ul>");
        // Take only emails from recipients
        // let recipients = this.selectedRecipients.map(recipient => recipient.email);
        var newCommunication = {
            recipients: this.model.recipients,
            recipientsCc: null,
            recipientsBcc: null,
            attachments: this.model.attachments,
            subject: this.model.subject,
            body: body,
            sendDocs: true,
            companyData: this.data.contract.companyData,
            propertyName: this.data.contract.propertyName,
        };
        if (Array.isArray(this.model.recipientsCc) &&
            this.model.recipientsCc.length) {
            newCommunication = tslib_1.__assign({}, newCommunication, { recipientsCc: this.model.recipientsCc });
        }
        else {
            delete newCommunication.recipientsCc;
        }
        if (Array.isArray(this.model.recipientsBcc) &&
            this.model.recipientsBcc.length) {
            newCommunication = tslib_1.__assign({}, newCommunication, { recipientsBcc: this.model.recipientsBcc });
        }
        else {
            delete newCommunication.recipientsBcc;
        }
        this.subscriptions.push(this.communicationsService
            .create(newCommunication)
            .pipe(finalize(function () {
            _this.formBtnOptions.active = false;
            _this.formBtnOptions.disabled = false;
            _this.dialogIsLoading = false;
        }))
            .subscribe(function (res) {
            if (res.status) {
                var data = tslib_1.__assign({}, res.data, { cancellationType: _this.model.cancellationType, selectedDocs: _this.selectedDocs });
                _this.toastrService.success(res.message);
                _this.communicationsService.onCommunicationCreated();
                _this.onClose(data, true);
                return;
            }
            _this.toastrService.error(_this.translateService.instant("common.errors.unknown"));
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Escape a value written into the HTML of the message (a document name or a link)
     *
     * @since 3.0.0
     */
    CancelContractDialogComponent.prototype.escapeHtml = function (value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    };
    /**
     * Update recipients basing on radio buttons changes
     *
     * @since 1.0.0
     */
    CancelContractDialogComponent.prototype.onChooseRecipientDialogOpen = function (key) {
        var _this = this;
        if (!key || !this.phonebook || !this.phonebook.length) {
            this.toastrService.error(this.translateService.instant("common.words.display_no_data"));
            return;
        }
        // Open dialog
        var dialogRef = this.chooseRecipientsDialog.open(ChooseRecipientDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                phonebook: this.phonebook,
                model: this.model[key],
            },
        });
        // On dialog closing, let's update model
        this.subscriptions.push(dialogRef.afterClosed().subscribe(function (res) {
            var _a;
            if (res) {
                var phonebookEmails_1 = _this.phonebook.map(function (contact) { return contact.email; });
                var customInsertedEmails = _this.model[key]
                    ? _this.model[key].filter(function (email) { return !phonebookEmails_1.includes(email); })
                    : [];
                var newData = tslib_1.__spread(res, customInsertedEmails);
                _this.model = tslib_1.__assign({}, _this.model, (_a = {}, _a[key] = newData, _a));
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    return CancelContractDialogComponent;
}());
export { CancelContractDialogComponent };
